module.exports = (theme) => ({
  ".tooltip": { position: "relative", display: "inline-block" },
  ".tooltip::after": {
    width: theme("spacing.5xl"),
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
    fontFamily: theme("fontFamily.regular"),
    fontWeight: theme("fontWeight.regular"),
    fontSize: theme("fontSize.sm"),
    borderRadius: theme("spacing.2xs"),
    display: "none",
    paddingTop: theme("spacing.xs"),
    paddingRight: theme("spacing.sm"),
    paddingBottom: theme("spacing.xs"),
    paddingLeft: theme("spacing.sm"),
    textAlign: "left",
    position: "absolute",
    zIndex: 30,
    content: "attr(aria-label)",
  },
  ".tooltip::before": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    content: "' '",
    display: "none",
    position: "absolute",
    width: theme("spacing.sm"),
    height: theme("spacing.sm"),
    borderRadius: "2px 0px 2px 0px",
    zIndex: 30,
  },
  ".tooltip.open::after, .tooltip:hover::after, .tooltip:focus::after, .tooltip.open::before, .tooltip:hover::before, .tooltip:focus::before":
    {
      display: "block",
    },
  ".tooltip.close::after, .tooltip.close:hover::after, .tooltip.close:focus::after, .tooltip.close::before, .tooltip.close:hover::before, .tooltip.close:focus::before":
    {
      display: "none !important",
    },
  ".tooltip.top::after, .tooltip:not(.bottom)::after": {
    content: "attr(aria-label)",
    top: "0",
    left: "50%",
    transform: "translate(-50%, calc(-100% - 10px))",
  },
  ".tooltip.top.left-align::after, .tooltip:not(.bottom).left-align::after": {
    left: "0",
    transform: "translateY(calc(-100% - 10px))",
  },
  ".tooltip.top.right-align::after, .tooltip:not(.bottom).right-align::after": {
    left: "auto",
    right: "0",
    transform: "translateY(calc(-100% - 10px))",
  },
  ".tooltip.top::before, .tooltip:not(.bottom)::before": {
    top: "0",
    left: "50%",
    transform: "translate(-50%, calc(-100% - 5px)) rotate(45deg)",
  },
  ".tooltip.bottom::after": {
    content: "attr(aria-label)",
    bottom: "0",
    left: "50%",
    transform: "translate(-50%, calc(100% + 10px))",
  },
  ".tooltip.bottom.right-align::after": {
    left: "0",
    transform: "translateY(calc(100% + 10px))",
  },
  ".tooltip.bottom.left-align::after": {
    left: "auto",
    transform: "translateY(calc(100% + 10px))",
  },
  ".tooltip.bottom::before": {
    bottom: "0",
    left: "50%",
    transform: "translate(-50%, calc(100% + 5px)) rotate(45deg)",
  },
  ".tooltip.blue::before, .tooltip.blue::after": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    color: theme("colors.primary.white"),
  },
  ".tooltip.yellow::before, .tooltip.yellow::after": {
    backgroundColor: theme("colors.primary.yellow.DEFAULT"),
    color: theme("colors.primary.black.DEFAULT"),
  },
  ".tooltip.black::before, .tooltip.black::after": {
    backgroundColor: theme("colors.primary.black.DEFAULT"),
    color: theme("colors.primary.white"),
  },
  ".tooltip.fluid::after": { width: "auto", maxWidth: theme("spacing.5xl") },
  ".tooltip.narrow::after": { width: "10rem" },
});
